import React, { Suspense, lazy } from "react";
import { Modal, Spin } from "antd";

// Lazy-loaded — react-filerobot-image-editor (+ its own konva/react-konva
// dependency) is a few hundred KB, not something every chat panel load
// should pay for just because the review modal exists. Only fetched the
// first time someone actually clicks "Edit" on an image.
const FilerobotImageEditor = lazy(() => import("react-filerobot-image-editor"));

// Text has no native "background pill" property in Filerobot's own Text
// tool (color/font/size only) — the closest to a movable, customizable
// rounded-white-background label is a Rect (cornerRadius + fill) layered
// with a Text object on top, both freely draggable independently. That's
// two objects, not one atomic "pill with text", but it's the same visual
// result using the editor's own stock tools rather than a custom canvas
// overlay.
export function ImageEditorModal({ open, source, onSave, onClose, zIndex }) {
  if (!open) return null;
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      destroyOnHidden
      zIndex={zIndex}
      width="92vw"
      styles={{ body: { height: "82vh", padding: 0 } }}
    >
      <Suspense fallback={
        <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Spin size="large" />
        </div>
      }>
        <FilerobotImageEditor
          source={source}
          onSave={(editedImageObject) => {
            onSave(editedImageObject);
          }}
          onBeforeSave={() => false}
          onClose={() => onClose()}
          closeAfterSave
          annotationsCommon={{ fill: "#000000" }}
          Text={{ text: "Add text…", fontSize: 28 }}
          Rect={{ cornerRadius: 16, fill: "#ffffff", stroke: "transparent" }}
          Pen={{ stroke: "#ff3b30", strokeWidth: 4 }}
          Rotate={{ angle: 90, componentType: "slider" }}
          tabsIds={["Adjust", "Annotate"]}
          defaultTabId="Annotate"
          defaultToolId="Pen"
          savingPixelRatio={0}
          previewPixelRatio={0}
          avoidChangesNotSavedAlertOnLeave={false}
        />
      </Suspense>
    </Modal>
  );
}
